export let HttpCodes = /*#__PURE__*/function (HttpCodes) {
  HttpCodes[HttpCodes["ACCEPTED"] = 202] = "ACCEPTED";
  HttpCodes[HttpCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpCodes[HttpCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpCodes[HttpCodes["CONFLICT"] = 409] = "CONFLICT";
  HttpCodes[HttpCodes["GONE"] = 410] = "GONE";
  HttpCodes[HttpCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  return HttpCodes;
}({});
export let Method = /*#__PURE__*/function (Method) {
  Method["DELETE"] = "DELETE";
  Method["GET"] = "GET";
  Method["PATCH"] = "PATCH";
  Method["POST"] = "POST";
  Method["PUT"] = "PUT";
  return Method;
}({});